import axios from 'axios';
import router from '../router';
const getClient = (baseUrl = null) => {
  const options = {
    baseURL: baseUrl,
  };
  const client = axios.create(options);
  client.interceptors.request.use(
    (requestConfig) => {
      requestConfig.baseURL = process.env.VUE_APP_BASE_URL;
      requestConfig.headers.token = localStorage.getItem('token');
      return requestConfig;
    },
    (requestError) => {
      return Promise.reject(requestError);
    },
  );
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      switch (error.response.status) {
        case 400:
          console.log('incorrect request payload sent');
          break;
        case 401:
          console.log('not authorized for requested resource');
          router.push('/');
          localStorage.clear();
          sessionStorage.clear();

          break;
        case 403:
          console.log('requested resource not found');
          break;
        case 404:
          console.log('requested resource not found');
          break;
        default:
          console.log('default requested intecept');
          break;
      }
      return Promise.reject(error);
    },
  );
  return client;
};
class ApiClient {
  constructor(baseUrl = null) {
    this.client = getClient(baseUrl);
  }

  static async get(url, conf = {}) {
    return await this.getClient
      .get(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }

  static async delete(url, conf = {}) {
    return await this.getClient
      .delete(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }

  static async post(url, data = {}, conf = {}) {
    return await this.getClient
      .post(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  static async postWithFormData(url,formData = {},conf = {}){
    return await this.getClient
      .post(url,formData,conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  static async put(url, data = {}, conf = {}) {
    return await this.getClient
      .put(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }

  static async patch(url, data = {}, conf = {}) {
    return await this.getClient
      .patch(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
}

export { ApiClient };

export default {
  get(url, conf = {}) {
    return getClient()
      .get(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },

  delete(url, conf = {}) {
    return getClient()
      .delete(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },

  post(url, data = {}, conf = {}) {
    return getClient()
      .post(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },
  postWithFormData(url,formData = {},conf = {}){
    return getClient()
      .post(url,formData,conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },
  put(url, data = {}, conf = {}) {
    return getClient()
      .put(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },

  patch(url, data = {}, conf = {}) {
    return getClient()
      .patch(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },
};
